// extracted by mini-css-extract-plugin
module.exports =  {"updateImageBlock":"updateImageBlock__CKEFj","customColHeader":"customColHeader__cQHO3","partNoTitleSuffix":"partNoTitleSuffix__vDebB"};